<template>
    <div>
        <p class="simple-error" v-if="containsRen1Assets">
            <b>The Ren 1.0 network is shutting down.</b> The Ren team asks everyone with ren-wrapped assets like renBTC to <b>unwrap them ASAP, or risk losing them</b>. Curve has no control over this, we hope this notice can help everyone holding ren-wrapped assets to act on time. If you have any such assets deposited on Curve, you should withdraw them from Curve, then follow Ren's instructions here: <a href="https://twitter.com/renprotocol/status/1600559366440390657" target="_blank" rel="noopener noreferrer">https://twitter.com/renprotocol/status/1600559366440390657</a>
        </p>
    </div>
</template>

<script>

import coins from '@/constants/coins';

export default {
    props: [
        'pool',
    ],
    computed: {
        containsRen1Assets() {
            const poolCoins = [
                ...this.pool.coins,
                ...(this.pool.metaCoins || []),
            ];
            return (
                'renbtc' in coins &&
                poolCoins.some((coin) => coin.id === coins.renbtc.id)
            );
        },
    },
}
</script>

<style>
    .simple-error {
        margin-bottom: 1.5em;
    }
</style>